/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface HeadcountApprovalJobDescriptionsMinimalJobDescriptionModel {
  /**
   * The unique id of the job description.
   */
  id: string;
  /**
   * Either jobAd or jobDescription
   */
  type: HeadcountApprovalJobDescriptionsMinimalJobDescriptionModelTypeEnum;
  /**
   * The title of the job description.
   */
  title: string | null;
  /**
   * The organizational code.
   */
  orgCode?: string | null;
  /**
   * The unique id of the job code (from Mercer).
   */
  jobCodeId?: string | null;
  /**
   * The id of the creator.
   */
  createdByUserId?: string | null;
  /**
   * The creation date.
   */
  createdAt?: string | null;
  /**
   * The job code associated with the job description.
   */
  jobCode?: string | null;
}
export enum HeadcountApprovalJobDescriptionsMinimalJobDescriptionModelTypeEnum {
  JobAd = 'JobAd',
  JobDescription = 'JobDescription'
}
